import React from 'react';
import { Card, Field, inputCls } from './ui';

export default function SecurityTab({ settings, extra, setExtra }) {
  const models = settings.availableModels || [];
  return (
    <Card title="Güvenlik ve bütçe">
      <Field label="Model" hint="Tüm modeller aynı güvenlik süzgecinden geçer. Varsayılan gpt-5-nano.">
        <select className={inputCls} value={extra.model} onChange={(e) => setExtra({ ...extra, model: e.target.value })}>
          {models.map((m) => <option key={m.id} value={m.id}>{m.label || m.id} ({m.provider})</option>)}
        </select>
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Günlük bütçe (USD, 0-100)"><input type="number" min={0} max={100} step="0.5" className={inputCls} value={extra.dailyBudgetUsd} onChange={(e) => setExtra({ ...extra, dailyBudgetUsd: e.target.value })} /></Field>
        <Field label="Kayıt saklama (gün, 7-730)"><input type="number" min={7} max={730} className={inputCls} value={extra.retentionDays} onChange={(e) => setExtra({ ...extra, retentionDays: e.target.value })} /></Field>
      </div>
      <Field label="Katalog kaynak URL (https)"><input className={inputCls} value={extra.catalogSourceUrl} placeholder="https://..." onChange={(e) => setExtra({ ...extra, catalogSourceUrl: e.target.value })} /></Field>
      <Field label="Konuşma başına en fazla mesaj" hint="Salt okunur; değiştirmek için geliştirici gerekir.">
        <input className={inputCls} value={settings.maxMsgsPerConv ?? ''} disabled readOnly />
      </Field>
    </Card>
  );
}
